import Badge from 'components/partials/badge/badge';

import type { CriticalPopulationResponseOrigin } from 'api/generated/schemas';

import Icons from 'assets/icons';

interface OriginBadgeProps {
  origin: CriticalPopulationResponseOrigin | undefined;
}

const OriginBadge = ({ origin }: OriginBadgeProps) =>
  origin === 'RECOMMENDED' ? (
    <Badge
      text="Recommended"
      variant="highlight-outlined"
      icon={<Icons.MarkIcon className="size-3.5" aria-hidden="true" />}
    />
  ) : (
    <Badge text="Custom" variant="reserve-outlined" />
  );

export default OriginBadge;
